import { createContext, useContext } from "react";
import StreakThemeManager from "../component/StreakThemeManager";
import { StepDetail } from "../component/StreakTypes";


interface StreakContextType {
  days: number;
  currentStep: number;
  themeManager: StreakThemeManager;
  stepDetails: StepDetail[];
  isStepActive: (index: number) => boolean;
  pendingStreakImg?: string;
  filledStreakImg?: string;
  footerText?: string;
  footerLink?: string;
  checkedUponCompletion?: boolean;
  showFooter?: boolean;
}

export const StreakContext = createContext<StreakContextType | undefined>(undefined);

export const useStreak = () => {
  const context = useContext(StreakContext);
  if (!context) {
    throw new Error('Streak compound components must be used within Streak component');
  }
  return context;
};